export default __webpack_public_path__ + "static/media/no-group.e3867e2e.png";